import { ICuttingBaseMaterial } from '../models/cutting/cutting-base-material.model';
import { CuttingMaterial } from '../models/cutting/cutting-material.model';

export class BazisMaterialHelper {
  // TODO: На клиенте вообще не должно быть склеенных названий материалов
  static readonly matNameDelimiter = '\r';

  static extractMaterialName(material: string): string {
    const delimeterPos = material.indexOf(this.matNameDelimiter);
    if (delimeterPos > 0) {
      return material.substring(0, delimeterPos).trim();
    }
    return material;
  }

  static extractMaterialCode(material: string): string {
    const delimeterPos = material.indexOf(this.matNameDelimiter);
    if (delimeterPos > 0) {
      return material.substring(delimeterPos + 1).trim();
    }

    return '';
  }

  static increaseMaterial(name: string, article: string): string {
    return article ? name + this.matNameDelimiter + article : name;
  }

  static formatMaterialName(material: string, articleText: string = $localize`Артикул`): string {
    let name = material;
    let article = '';
    const delimeterPos = material.indexOf(this.matNameDelimiter);
    if (delimeterPos > 0) {
      [name, article] = material.split(this.matNameDelimiter);
    }
    return BazisMaterialHelper.formatMaterialNameAndArticle(name, article, articleText);
  }

  static formatMaterialNameAndArticle(name: string, article: string, articleText: string = $localize`Артикул`): string {
    let result = name;

    if (article !== '') {
      result = `${name} (${articleText} ${article})`;
    }

    return result;
  }

  static materialComparer(item: ICuttingBaseMaterial): (m: ICuttingBaseMaterial) => boolean {
    return m => BazisMaterialHelper.compareMaterialNames(m.name, m.article, item.name, item.article);
  }

  static compareMaterials(item1: ICuttingBaseMaterial, item2: ICuttingBaseMaterial): boolean {
    return BazisMaterialHelper.materialComparer(item1)(item2);
  }

  static compareMaterialNames(
    materialName1: string,
    materialArticle1: string,
    materialName2: string,
    materialArticle2: string
  ): boolean {
    return materialName1 + materialArticle1 === materialName2 + materialArticle2;
  }
}
